export default {
  namespaced: true,
  state: {
    // El documento llega ya convertido a HTML desde el backend: aquí no se parsea
    // markdown ni se arma el índice, solo se guarda lo que vino.
    document: null,
    loaded: false
  },
  getters: {
    document(state) {
      return state.document;
    },
    sections(state) {
      return state.document ? state.document.sections : [];
    },
    // La documentación no cambia durante una sesión, así que se pide una sola vez y
    // se reusa al volver a entrar a la vista.
    loaded(state) {
      return state.loaded;
    }
  },
  mutations: {
    SET_DOCUMENT(state, value) {
      state.document = value;
      state.loaded = true;
    }
  },
  actions: {
    getDocument({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.loaded) {
          resolve(state.document);
          return;
        }

        axios.get('docs').then((response) => {
          commit('SET_DOCUMENT', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
      });
    }
  }
}
